import React, { createContext, useState, useContext, useMemo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

const JobsContext = createContext();

export const JobsProvider = ({ children }) => {
  const initialJobsData = {jobs: []}

  const [JobsData, setJobsData] = useState(initialJobsData);
  const [isHeatMap, setIsHeatMap] = useState(false);
  const [myJob, setMyJob] = useState(false);

  const updateJobsData = useCallback((data) => {
    setJobsData(() => ({ jobs: [] }));

    setTimeout(() => {
      setJobsData(() => ({ jobs: data.jobs })); 
    }, 0);
  }, []);
  const updateToggle = (data) =>{
    setIsHeatMap(data);
  }
  const updateToggleJobs = (data) =>{
    setMyJob(data);
  }

  const resetJobsData = useCallback(() => {
    setJobsData(initialJobsData);
  }, [initialJobsData]);

  // useEffect(() => {
  //   console.log('JobsData updated:', JobsData);
  // }, [JobsData]); 
  
  const contextValue = useMemo(
    () => ({
      JobsData,
      isHeatMap,
      setJobsData,
      myJob,
      updateToggleJobs,
      updateJobsData,
      resetJobsData,
      updateToggle
    }),
    [ resetJobsData,JobsData, updateToggle, updateToggleJobs]
  );

  return <JobsContext.Provider value={contextValue}>{children}</JobsContext.Provider>;
};

JobsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useJobsData = () => useContext(JobsContext);
